import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx";
import ConfirmButton from "../common/button/confirmbutton.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import { Link } from "react-router-dom";
import ActionButton from "../common/button/actionbutton.component.jsx";
import SendEmailModal from "../common/email/sendemail.component.jsx";
import StandardList from "../common/listing/list.component.jsx";
import NoResult from "../common/listing/noresult.component.jsx";
import Pagination from "../common/listing/pagination.component.jsx";
import InlineEditUser from "../common/inline-edit/user.component.jsx";
import SortLink from "../common/listing/sortlink.component.jsx";
import CalendarEventStatusBadge from "./calendareventstatusbadge.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import AnalyticsQuoteEmails from "../quote/analytics/quoteemails.component.jsx";
import InlineEditSchedulingAvailableFrom from '../common/inline-edit/document.component.jsx';
import InlineEditSchedulingCustomFields from './InlineEditSchedulingCustomFields';
import SchedulingPageStatusBadge from "./status.component.jsx";
import { getEventName } from '../name-helpers/eventNameHelper';

class SchedulingPageAnalytics extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            schedulingPage: this.props.schedulingPage || null,
            proposal: this.props.proposal || null,
            onRefresh: this.props.onRefresh || function () { },
            onEdit: this.props.onEdit || function () { },
            redirect: '',
            modal: '',
            moreLoading: false,
            loading: false,
            isEditable: this.props.schedulingPage && this.props.schedulingPage.attributes.deletedAt === '',
            pageSize: 10,
            activePage: 1,
            headers: [],
            rows: [],
            totalItemsCount: 0,
            buttonCopyLabel: '',
            sortField: 'startAt',
            asc: false,
            emails: this.props.emails || [],
            schedulingPageEmailTemplates: [],
        }
        this.handleRefreshSchedulingPage = this.handleRefreshSchedulingPage.bind(this)
        this.archive = this.archive.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.sendEmail = this.sendEmail.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
        this.activate = this.activate.bind(this)
        this.deactivate = this.deactivate.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.copyLink = this.copyLink.bind(this)
        this.clearCopyLink = this.clearCopyLink.bind(this)

        this.handleSortLinkChange = this.handleSortLinkChange.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            schedulingPage: nextProps.schedulingPage || null,
            proposal: nextProps.proposal || null,
            isEditable: nextProps.schedulingPage && nextProps.schedulingPage.attributes.deletedAt === '',
            emails: nextProps.emails || [],
        })
    }

    componentDidMount() {
        /*  AppContext.getApiClient().get('/email-templates?templateKey=send-scheduling-page').then(res => {
             this.setState({
                 schedulingPageEmailTemplates: res.data,
             })
         }) */
        this.refreshCalendarEvents()
    }

    handleRefreshSchedulingPage() {
        this.state.onRefresh(this.state.schedulingPage.id)
        this.refreshCalendarEvents()
    }

    handleOnEdit(e) {
        e.preventDefault()
        this.state.onEdit(this.state.schedulingPage.id)
    }

    archive(event) {
        event.preventDefault()
        return AppContext.getApiClient().delete('/scheduling-pages/' + this.state.schedulingPage.id, {}).then(q => {
            this.handleRefreshSchedulingPage()
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.handleRefreshSchedulingPage()
    }

    handlePageSizeChange(size) {
        this.setState({
            activePage: 1,
            pageSize: size
        }, () => {
            this.refreshCalendarEvents()
        })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.refreshCalendarEvents()
        })
    }

    refreshCalendarEvents() {
        this.setState({
            loading: true,
        })
        let postData = {
            keywords: '*',
            objects: ['calendar-events'],
            fields: [],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: this.state.sortField,
            sortAsc: this.state.asc,
            filters: {
                schedulingPageId: this.state.schedulingPage.id,
            },
            lightResult: true,
        }
        AppContext.getApiClient().post('/listing/search', postData).then(res => {
            const r = res
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                totalItemsCount: r.metadata.totalItemsCount,
                loading: false,
            })
        })
    }

    handleSortLinkChange(sortField, asc) {
        this.setState({
            sortField: sortField,
            asc: asc,
        }, () => {
            this.refreshCalendarEvents()
        })
    }

    headers() {
        return [
            < SortLink
                field={'identifier'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.id_label"
                    defaultMessage="ID"
                />
            </SortLink >,
            < SortLink
                field={'contact.nameSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.contact_label"
                    defaultMessage="Contact"
                />
            </SortLink >,
            < SortLink
                field={'locationNameSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.location_label"
                    defaultMessage="Location"
                />
            </SortLink >,
            < SortLink
                field={'startAt'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.start_at_label"
                    defaultMessage="Start at"
                />
            </SortLink >,
            < SortLink
                field={'endAt'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.end_at_label"
                    defaultMessage="End at"
                />
            </SortLink >,
            < SortLink
                field={'user.nameSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="scheduling_page.events.listing.headers.assigned_to_label"
                    defaultMessage="Assigned to"
                />
            </SortLink >,
            <FormattedMessage
                id="scheduling_page.events.listing.headers.status_label"
                defaultMessage="Status"
            />,
        ]
    }

    row(calendarEvent) {
        return [
            <Link key={calendarEvent.id} to={'/calendar-events/' + calendarEvent.id + '/edit'}>
                {calendarEvent.identifier}
            </Link>,
            calendarEvent.contact ?
                <Link key={calendarEvent.contactId} to={'/contacts/' + calendarEvent.contactId + '/details'}>
                    {calendarEvent.contact.name}
                </Link> : '-',
            GlobalHelper.isValidUrl(calendarEvent.locationName) ?
                <a href={calendarEvent.locationName} target={'_blank'}>{calendarEvent.locationName}</a> : calendarEvent.locationName,
            calendarEvent.startAt ? [<div><FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(calendarEvent.startAt)} /></div>,
            <FormattedTime value={new Date(calendarEvent.startAt)} />] : '-',
            calendarEvent.endAt ? [<div><FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(calendarEvent.endAt)} /></div>,
            <FormattedTime value={new Date(calendarEvent.endAt)} />] : '-',
            calendarEvent.user.name,
            <CalendarEventStatusBadge status={calendarEvent.status} />,
        ]
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleCloseModal}
                hash={this.state.proposal.attributes.hash}
                proposalType={'scheduling-page'}
                publicLink={this.state.proposal.attributes.publicLink}
            />
        })
    }

    activate(event) {
        event.preventDefault()
        AppContext.getApiClient().post('/scheduling-pages/' + this.state.schedulingPage.id + '/activate', {}).then(res => {
            this.handleRefreshSchedulingPage()
        })
    }

    deactivate(event) {
        event.preventDefault()
        AppContext.getApiClient().post('/scheduling-pages/' + this.state.schedulingPage.id + '/deactivate', {}).then(res => {
            this.handleRefreshSchedulingPage()
        })
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        let proposal = this.state.proposal
        if (templateKey === 'send-contract' && this.state.contractProposal) {
            proposal = this.state.contractProposal
        }

        AppContext.getApiClient()
            .post('/proposals/' + proposal.attributes.hash + '/send-by-email', {
                subject: subject,
                toEmail: toEmail,
                ccEmail: ccEmail,
                content: content,
                buttonLabel: buttonLabel,
                fromEmail: fromEmail,
                bccEmail: bccEmail,
                fromName: fromName,
            })
            .then(res => {
                this.handleRefreshSchedulingPage()
            })
    }

    sendEmail(event, templateId) {
        event.preventDefault()
        const attr = this.state.schedulingPage.attributes || {}
        this.setState({
            modal: <SendEmailModal
                fromEmail={[attr.sendSchedulingPageFromEmailAddress]}
                isCustomFromName={attr.sendSchedulingPageFromName != ""}
                fromName={attr.sendSchedulingPageFromName ? attr.sendSchedulingPageFromName : attr.seller.attributes.name}
                lastEmailSubject={attr.sendSchedulingPageEmailSubject}
                lastEmailContent={attr.sendSchedulingPageEmailContent}
                lastEmailButtonLabel={attr.sendSchedulingPageEmailButtonLabel}
                title={<FormattedMessage
                    id="scheduling_page.send_email.modal.title"
                    defaultMessage="Send scheduling page email"
                />}
                onSubmit={this.sendProposal}
                onClose={this.handleCloseModal}
                proposalType={'scheduling-page'}
                templateKey={'send-scheduling-page'}
                templateId={attr.sendSchedulingPageEmailTemplateId}
            />
        })
    }

    copyLink(e) {
        e.preventDefault()
        let copyText = document.getElementById("proposalPublicLink");
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy");
        this.setState({
            buttonCopyLabel: <FormattedMessage
                id="scheduling_page.analytics.link_copied_btn"
                defaultMessage="Link Copied!"
            />
        })
        setTimeout(this.clearCopyLink, 2000)
    }

    clearCopyLink() {
        this.setState({
            buttonCopyLabel: ''
        })
    }

    render() {
        if (!this.state.schedulingPage || !this.state.proposal) {
            return <div />
        }

        let list = <StandardList
            smallLine={true}
            className="row pt-2 d-none d-sm-none d-md-block"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        } else if (this.state.rows.length === 0) {
            list = <NoResult
                className={'py-2'}
                title={<FormattedMessage
                    id="scheduling_page.analytics.no_event_yet_title"
                    defaultMessage="No scheduled events yet."
                />}
                message={<FormattedMessage
                    id="scheduling_page.analytics.no_events_yet_msg"
                    defaultMessage="No {eventName} has been booked yet. Time to share the link!"
                    values={{ eventName: getEventName(this.props.intl) }}
                />}
                noButton={true}
            />
        }

        const canActivate = ['inactive'].includes(this.state.schedulingPage.attributes.status)

        return <div className={'row analytics-page py-3 mb-5'}>
            {this.state.redirect}
            {this.state.modal}
            <div className="col-12 ui-module">
                <div className={"row"}>
                    <div className={"col-12 col-md-6 border-right"}>
                        <h3 className={'m-0 d-flex align-items-center'}>
                            <FormattedMessage
                                id="scheduling_page.analytics.title_label"
                                defaultMessage="Scheduling Page {number}"
                                values={{
                                    number: this.state.schedulingPage.attributes.identifier
                                }}
                            />
                            <h6 className="ml-2 d-inline mb-0">
                                <SchedulingPageStatusBadge status={this.state.schedulingPage.attributes.status} />
                            </h6>
                        </h3>
                        <div className={'w-100'}>
                            <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="scheduling_page.edit.details.title_label"
                                        defaultMessage="Title"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    {this.state.schedulingPage.attributes.title}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.schedulingPage.attributes.contactCustomFieldIds.length > 0 &&
                            <>
                                <div className={'w-100'}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="scheduling_page.edit.details.custom_fields_label"
                                                defaultMessage="Contact custom fields"
                                            />
                                        </strong>
                                    </label>
                                </div>
                                <p className={'m-0'}>
                                    <InlineEditSchedulingCustomFields
                                        name={'scheduling-page-custom-fields'}
                                        editable={false}
                                        schedulingPage={this.state.schedulingPage}
                                    />
                                </p>
                            </>
                        }
                    </div>
                    <div className={"col-12 col-md-6 d-flex"}>
                        <div className={'w-100 text-right'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2">
                                    <strong>
                                        <FormattedMessage
                                            id="scheduling_page.analytics.assign_to_label"
                                            defaultMessage="Assigned to"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <p className={'m-0'}>
                                <Icon value={'user'} /> <InlineEditUser
                                    editable={false}
                                    value={this.state.schedulingPage.attributes.seller.attributes.name}
                                    userId={this.state.schedulingPage.attributes.seller.id} />
                            </p>

                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2">
                                    <strong>
                                        <FormattedMessage
                                            id="scheduling_page.edit.details.available_from_label"
                                            defaultMessage="Available from"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <p className={'m-0'}>
                                <Icon value={'invoice'} /> <InlineEditSchedulingAvailableFrom
                                    editable={false}
                                    documentId={this.state.schedulingPage.attributes.availableFrom} />
                            </p>

                            {this.state.schedulingPage.attributes.location ? <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2">
                                    <strong>
                                        <FormattedMessage
                                            id="scheduling_page.analytics.location_label"
                                            defaultMessage="Location"
                                        />
                                    </strong>
                                </label>
                            </div> : null}
                            {this.state.schedulingPage.attributes.location ? <p className={'m-0'}>
                                <Icon value={'map-marker-alt'} /> {this.state.schedulingPage.attributes.location.attributes.name}
                            </p> : null}
                        </div>
                    </div>
                    {this.state.emails.length > 0 &&
                        [<div className="col-md-12 px-0 mt-3">
                            <h5 className="p-0 pl-3 border-bottom-0 mb-1">
                                <Icon value={'envelope'} className={'mr-2'} />
                                <FormattedMessage
                                    id="scheduling_page.analytics.emails"
                                    defaultMessage="Last emails sent"
                                />
                            </h5>
                        </div>,
                        <div className="col-12">
                            <AnalyticsQuoteEmails
                                proposal={this.state.proposal}
                                emails={this.state.emails}
                                isEditable={false}
                            />
                        </div>]
                    }
                </div>
            </div>
            <div className="col-md-12 px-0">
                <h4 className="p-0">
                    <Icon value={'calendar-day'} className={'mr-2'} />
                    <FormattedMessage
                        id="scheduling_page.analytics.events"
                        defaultMessage="Events"
                    />
                </h4>
            </div>
            <div className="col-12 ui-module">
                {this.state.schedulingPage.attributes.status === 'inactive' ? <div className={'w-100 pb-2'}>
                    <Icon value={'info'} />
                    <FormattedMessage
                        id="scheduling_page.analytics.inactive_warning"
                        defaultMessage="This scheduling page is inactive. No more {eventName}s will be booked."
                        values={{ eventName: getEventName(this.props.intl) }}
                    />
                </div> : ''}
                <div className={'w-100 d-flex flex-wrap'}>
                    <div className={'mr-2 bg-secondary px-3'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label py-2 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="scheduling_page.analytics.number_of_bookings_label"
                                        defaultMessage="Number of bookings"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h5 className={'m-0 text-white border-0'}>
                            {this.state.totalItemsCount}
                        </h5>
                    </div>
                    <div className={'mr-2 bg-secondary px-3'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label py-2 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="scheduling_page.analytics.number_of_visits_label"
                                        defaultMessage="Number of visits"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h5 className={'m-0 text-white border-0'}>
                            {this.state.proposal.attributes.numberOfVisits}
                        </h5>
                    </div>
                    <div className={'mr-2'}>
                        <div className={" w-100"}>
                            <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview} >
                                <Icon value={"eye"} className={"mr-1"} />
                                <FormattedMessage
                                    id="scheduling_page.analytics.preview_btn"
                                    defaultMessage="Preview"
                                />
                            </button>
                        </div>
                    </div>
                </div>
                <div className={'w-100 border-bottom mt-3'}>
                </div>
                <div className={'w-100 d-flex mt-3 justify-content-center'}>
                    <div className={'mr-2 w-50'}>
                        <input
                            id={'proposalPublicLink'}
                            className="form-control form-control-lg"
                            type="text"
                            value={this.state.proposal.attributes.publicLink}
                        />
                    </div>
                    <div className={'mr-2'}>
                        <button className={'btn btn-lg ' + (this.state.buttonCopyLabel ? 'btn-success' : 'btn-primary')} onClick={this.copyLink}>
                            <Icon value={"copy"} className={"mr-1"} />
                            {this.state.buttonCopyLabel ? this.state.buttonCopyLabel : <FormattedMessage
                                id="scheduling_page.analytics.copy_link_btn"
                                defaultMessage="Copy Link"
                            />}
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-12 px-0 ">
                {list}
                <Pagination
                    showPageSize={true}
                    onPageSizeChange={this.handlePageSizeChange}
                    activePage={this.state.activePage}
                    pageSize={this.state.pageSize}
                    totalItemsCount={this.state.totalItemsCount}
                    onChange={this.handlePageChange}
                />
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {this.state.isEditable ? <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                <div className={"d-flex"}>
                                    <div className={""}>
                                        <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview} >
                                            <Icon value={"eye"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="scheduling_page.analytics.preview_btn"
                                                defaultMessage="Preview"
                                            />
                                        </button>
                                        <a className={'btn btn-sm btn-outline-primary mr-2 mb-2'} href={this.state.proposal.attributes.publicLink} target={'_blank'}>
                                            <Icon value={"external-link-alt"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="scheduling_page.analytics.open_scheduling_page_btn"
                                                defaultMessage="Open scheduling page"
                                            />
                                        </a>
                                    </div>
                                    <div className="mr-2 mb-2 ">
                                        <button className="btn btn-sm btn-outline-primary" type="button" id="dropdownMoreButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {!this.state.moreLoading ? <Icon value={"ellipsis-h"} className={"mr-1"} /> : <LoadingSpinner
                                                height={15}
                                                width={3}
                                                className="px-5"
                                            />}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                            <a className="dropdown-item" href="#" onClick={this.handleOnEdit}>
                                                <Icon value={"pen"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="scheduling_page.analytics.edit_btn"
                                                    defaultMessage="Edit"
                                                />
                                            </a>
                                            <ConfirmButton
                                                isLink={true}
                                                onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                                                onClick={this.archive}
                                                identifier={this.state.schedulingPage.attributes.identifier}
                                                message={<span>
                                                    <FormattedMessage
                                                        id="scheduling_page.analytics.delete_message"
                                                        defaultMessage="Are you sure you want to delete scheduling page {identifier} ?"
                                                        values={{
                                                            identifier: this.state.schedulingPage.attributes.identifier
                                                        }}
                                                    />
                                                </span>}
                                                className="dropdown-item text-danger"
                                            >
                                                <Icon value={"trash"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="scheduling_page.analytics.delete_btn"
                                                    defaultMessage="Delete"
                                                />
                                            </ConfirmButton>
                                        </div>
                                    </div>
                                </div>
                                <div className={""}>
                                    <button className="btn btn-primary mr-2 mb-2" onClick={this.sendEmail}>
                                        <Icon value={"envelope"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="scheduling_page.analytics.send_btn"
                                            defaultMessage="Send scheduling page"
                                        />
                                    </button>
                                    {/*  {
                                        this.state.schedulingPageEmailTemplates.length === 1 ?
                                            <button className="btn btn-primary mr-2 mb-2" onClick={this.sendEmail}>
                                                <Icon value={"envelope"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="scheduling_page.analytics.send_btn"
                                                    defaultMessage="Send scheduling page"
                                                />
                                            </button>
                                            :
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button id="btnGroupSchedulingEmailTemplate" type="button"
                                                    className={"btn btn-outline-primary dropdown-toggle"}
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <Icon value={"envelope"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="scheduling_page.analytics.send_btn"
                                                        defaultMessage="Send scheduling page"
                                                    />
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="btnGroupSchedulingEmailTemplate">
                                                    {
                                                        this.state.schedulingPageEmailTemplates.map(schedulingPageEmailTemplate => {
                                                            return <a key={schedulingPageEmailTemplate.id} className="dropdown-item"
                                                                href="#"
                                                                onClick={e => this.sendEmail(e, schedulingPageEmailTemplate.id)}>
                                                                {
                                                                    schedulingPageEmailTemplate.attributes.name ||
                                                                    <FormattedMessage
                                                                        id="templates.default_template_name"
                                                                        defaultMessage="Default template"
                                                                    />
                                                                }
                                                            </a>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                    } */}

                                    {canActivate ? <ActionButton className="btn btn-success mr-2 mb-2" onClick={this.activate}>
                                        <Icon value={"toggle-on"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="scheduling_page.analytics.activate_btn"
                                            defaultMessage="Activate"
                                        />
                                    </ActionButton> : ''}
                                    {['active'].includes(this.state.schedulingPage.attributes.status) ? <ActionButton className="btn btn-warning mr-2 mb-2" onClick={this.deactivate}>
                                        <Icon value={"toggle-off"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="scheduling_page.analytics.deactivate_btn"
                                            defaultMessage="Deactivate"
                                        />
                                    </ActionButton> : ''}
                                </div>
                            </div> : <div className="col-12">
                                <p className="text-align-right text-warning m-0">
                                    <FormattedMessage
                                        id="scheduling_page.analytics.archived_info"
                                        defaultMessage="This scheduling page is archived and can't be found in search results."
                                    />
                                </p>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }


}

export default injectIntl(SchedulingPageAnalytics)





// WEBPACK FOOTER //
// ./src/scheduling-page/analytics.component.jsx